import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EventEmiterService {

  private reloadViewSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public reloadView$: Observable<boolean> = this.reloadViewSubject.asObservable();

  constructor() { }

  public triggerReloadView() {
    this.reloadViewSubject.next(true);
  }
 
}
